import { useEffect, useState } from 'react';

const useIsLandscape = () => {
  const [isLandscape, setIsLandscape] = useState(false);

  useEffect(() => {
    const updateLandscapeState = () => {
      if (window.innerWidth > 920) {
        setIsLandscape(false);
        return;
      }

      const mediaQuery = window.matchMedia('(orientation: landscape)');
      setIsLandscape(mediaQuery.matches);
      if (mediaQuery.matches) {
        document.body.classList.add('goftinoCustom');
      } else {
        document.body.classList.remove('goftinoCustom');
      }
    };

    updateLandscapeState();

    window.addEventListener('resize', updateLandscapeState);

    return () => {
      window.removeEventListener('resize', updateLandscapeState);
    };
  }, []);

  return isLandscape;
};

export default useIsLandscape;
